import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Dropdown } from "react-bootstrap";
import { FilterSection } from "./FilterStyle";
import { FilterDropdownProps, DropdownOptions } from "../../../utils/types";
import ArrowIcon from "../../../assests/images/arrow-down.svg";

const FilterDropdown = ({ options = [], selectedFilter, setSelectedFilter, setFilterFlag }: FilterDropdownProps) => {
    const [selectedLabel, setSelectedLabel] = useState("");

    const validSelectedFilter = selectedFilter ?? '';
    useEffect(() => {
        const selectedOption = options.find(option => option.value?.toString() === validSelectedFilter.toString());
        if (selectedOption) {
            setSelectedLabel(selectedOption.label);
        }
    }, [selectedFilter, options]);

    return (
        <FilterSection>
            <Dropdown onSelect={(eventKey: any) => {
                setSelectedFilter(eventKey);
                setFilterFlag && setFilterFlag(true)
            }}>
                <Dropdown.Toggle variant="success" id="dropdown-basic"

                >
                    {selectedLabel || "All Campaigns"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {options.map((option: DropdownOptions, index: number) => (
                        <Dropdown.Item key={index + 1} eventKey={option.value}>
                            {option.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </FilterSection >
    );
};

export default FilterDropdown;
